import { render } from "./RouteSettingsProfiles.vue?vue&type=template&id=4720c3a9&ts=true"
import script from "./RouteSettingsProfiles.vue?vue&type=script&lang=ts"
export * from "./RouteSettingsProfiles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__